// Keyboard keys For easy reference

export const keyCodes = {
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  enter: 13,
  space: 32
}

export const keys = {
  end: 'End',
  home: 'Home',

  // Non IE, FIrefox specific keys
  arrowUp: 'ArrowUp',
  arrowDown: 'ArrowDown',
  arrowLeft: 'ArrowLeft',
  arrowRight: 'ArrowRight',

  // IE11, edge and firefox specific
  left: 'Left',
  right: 'Right',
  up: 'Up',
  down: 'Down',

  delete: 'Delete',
  enter: 'Enter',
  space: ' '
}
